import React from 'react'

import { useNavigation } from '../../Context'

const Container: React.FC = ({ children }) => {
  const { state } = useNavigation()

  return (
    <div
      className={`bg-white text-black space-y-10 py-8 pt-20 min-h-full ${
        state.collapsed ? 'w-20' : 'w-60'
      }`}
    >
      {children}
    </div>
  )
}

export default Container
